export enum UserStatus {
  UNDER_REVIEW = "UNDER_REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  BLOCK = "BLOCK",
}

export const isBlockedStatus = (status: string | null | undefined): boolean =>
  status === UserStatus.REJECTED || status === UserStatus.BLOCK;

export const isUnderReview = (status: string | null | undefined): boolean =>
  status === UserStatus.UNDER_REVIEW;

export const isApproved = (status: string | null | undefined): boolean =>
  status === UserStatus.APPROVED;
